import axios from 'axios';
import Format from 'string-format';
import { CATEGORY_FORMAT } from '../_components/details/constants';
import { NOT_FOUND } from '../_utils/routes';
import {
  FETCH_CATEGORIES,
  FETCH_FORMATS,
  SEARCH_PROJECT_FORMATS_ENDPOINT,
} from './endpoints';
import { handleHTTPError } from './errorHandlerActions';
import {
  GET_SLIDE_PRESET_CATEGORIES,
  GET_SLIDE_PRESETS,
  RESET_SLIDE_PRESETS,
  SEARCH_SLIDE_PRESETS,
} from './types';

import { isEmpty } from 'lodash';

export const fetchCategories = (props, signalToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(Format(FETCH_CATEGORIES, CATEGORY_FORMAT), {
        cancelToken: signalToken,
      })
      .then((res) => {
        dispatch({
          type: GET_SLIDE_PRESET_CATEGORIES,
          payload: res.data.results,
          hasMore: res.data.next ? true : false,
        });
        resolve(res.data.results);
      })
      .catch((error) => {
        dispatch(handleHTTPError(error, props));
        reject();
      });
  });
};

export const fetchFormats =
  (key = '', props) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      let endpoint = Format(FETCH_FORMATS, key) + `&page=${props.page}`;
      axios
        .get(endpoint)
        .then((res) => {
          resolve(res.data);
          dispatch({
            type: GET_SLIDE_PRESETS,
            payload: res.data.results,
            groupKey: props.groupKey || 0,
            hasMore: res.data.next ? true : false,
          });
        })
        .catch((error) => {
          dispatch(handleHTTPError(error, props));
        });
    });
  };

export const searchFormats = (searchTerm, props) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(Format(SEARCH_PROJECT_FORMATS_ENDPOINT, searchTerm))
      .then((res) => {
        resolve(res.data);

        dispatch({
          type: SEARCH_SLIDE_PRESETS,
          payload: res.data.results,
        });
      })
      .catch((error) => {
        dispatch(handleHTTPError(error, props));
      });
  });
};

export const searchFormatWithSlug =
  (searchTerm, history, createDesignVideoProject) => (dispatch) => {
    return new Promise((resolve) => {
      axios
        .get(Format(SEARCH_PROJECT_FORMATS_ENDPOINT, searchTerm))
        .then((res) => {
          resolve(res.data);

          dispatch({
            type: SEARCH_SLIDE_PRESETS,
            payload: res.data.results,
          });
          if (isEmpty(res.data.results)) history.push(NOT_FOUND);
          createDesignVideoProject(res.data.results[0]);
        })
        .catch((error) => {
          dispatch(handleHTTPError(error));
        });
    });
  };

export const resetSlidePresets = () => {
  return {
    type: RESET_SLIDE_PRESETS,
  };
};
